import { useCallback, useMemo, useEffect } from 'react';
import { assoc } from 'ramda';

import {
  useMachineForm,
  useMachineValidate,
  useModels,
} from 'app/dataProviders/VendingDataProvider';
import type { ModelsState } from 'app/dataProviders/VendingDataProvider';

type Result = {
  models: ModelsState
  loadingModels: boolean
  modelSelection: Array<string>
  changeCurrentModel: (values: Array<string>) => void
}

export function useActualModels(): Result {
  const [{ modelId }, { update }] = useMachineForm();
  const [, , resetErrors] = useMachineValidate();

  const [models, loadingModels, requestModels] = useModels();

  const modelSelection = useMemo(() => (
    modelId
      ? [String(modelId)]
      : []
  ), [modelId]);

  const changeCurrentModel = useCallback((values: Array<string>) => {
    const [modelId_] = values;
    resetErrors();
    update(assoc('modelId', parseInt(modelId_, 10) || 0));
  }, [update, resetErrors]);


  useEffect(() => {
    requestModels();
  }, [requestModels]);

  return {
    models,
    loadingModels,
    modelSelection,
    changeCurrentModel,
  };
}
